<template>
  <div>
    <div class="d-flex align-items-center justify-content-center mb-3 title-wrapper">
      <div class="title">Betriebstagebuch Abfalleingang / Ausgang</div>
      <div class="subtitle">Genehmigungsbescheid 55.2-8851.8.1-10/91</div>
    </div>
    <!-- <b-form> -->
    <div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">1. Datum:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="date"
          v-model="formData.date"
          type="text"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">2. Platzwart:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="groundskeeper"
          v-model="formData.groundskeeper"
          type="text"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">3. Menge der abgelieferten Abfälle:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="quantityOfDeliveredWaste"
          v-model="formData.quantityOfDeliveredWaste"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1; flex-direction: column">
          <div style="font-size: 13px">(Einzelaufstellung im Register)</div>
          <div>4. Menge der abgelieferten Reststoffe:</div>
        </div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="quantityOfDeliveredResidues"
          v-model="formData.quantityOfDeliveredResidues"
          type="number"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">5. Dokumentation Probenahme Reststoffe:</div>
        <!-- <b-form-input
            style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange"
            id="documentationSamplesTakesOfResidues"
            v-model="formData.documentationSamplesTakesOfResidues"
            type="text"
            class="form-control"
            :placeholder="''"
            size="sm"
            @input="handleChange"
          /> -->
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange" class="form-control-sm">
          {{ formData.documentationSamplesTakesOfResidues }}
        </div>
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">6. Maßnahmen bei nicht genehmigungkonformer Anlieferung:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="measuresAtNonApprovedDelivery"
          v-model="formData.measuresAtNonApprovedDelivery"
          type="text"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">7. Technische Betriebsstörungen:</div>
        <!-- <b-form-input
            style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange"
            id="technicalMalfunction"
            v-model="formData.technicalMalfunction"
            type="text"
            class="form-control"
            :placeholder="''"
            size="sm"
          /> -->
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange" class="form-control-sm">
          {{ formData.technicalMalfunction }}
        </div>
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">8. Sonstige Betriebsstörungen:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="otherMalfunction"
          v-model="formData.otherMalfunction"
          type="text"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">9. Betriebszeiten der Anlage:</div>
        <!-- <b-form-input
            style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange"
            id="operatingTimesOfSystem"
            v-model="formData.operatingTimesOfSystem"
            type="text"
            class="form-control"
            :placeholder="''"
            size="sm"
          /> -->
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange" class="form-control-sm">
          {{ formData.operatingTimesOfSystem }}
        </div>
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">10. Beschwerden von Anliegern:</div>
        <!-- <b-form-input
            style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange"
            id="complaintsFromResidents"
            v-model="formData.complaintsFromResidents"
            type="text"
            class="form-control"
            :placeholder="''"
            size="sm"
          /> -->
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange" class="form-control-sm">
          {{ formData.complaintsFromResidents }}
        </div>
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">11. Nummer der Transportgenehmigung:</div>
        <!-- <b-form-input
            style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange"
            id="transportPermitNumber"
            v-model="formData.transportPermitNumber"
            type="text"
            class="form-control"
            :placeholder="''"
            size="sm"
          /> -->
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange" class="form-control-sm">
          {{ formData.transportPermitNumber }}
        </div>
      </div>
      <div style="margin: 20px 0; padding: 0 10px">Nebenbestimmung 4.4.7</div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">12. Angelieferte Abfallmenge:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="deliveredAmountOfWaste"
          v-model="formData.deliveredAmountOfWaste"
          type="text"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">13. Heizwertermittlung:</div>
        <!-- <b-form-input
            style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange"
            id="heizwertDetermination"
            v-model="formData.heizwertDetermination"
            type="text"
            class="form-control"
            :placeholder="''"
            size="sm"
          /> -->
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange" class="form-control-sm">
          {{ formData.heizwertDetermination }}
        </div>
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">14. Zusammensetzung der Abfallmengen:</div>
        <b-form-input
          style="width: 50%; flex-shrink: 0; flex-grow: 1"
          id="compositionOfWasteQuantities"
          v-model="formData.compositionOfWasteQuantities"
          type="text"
          class="form-control"
          :placeholder="''"
          size="sm"
        />
      </div>
      <div class="inputWrapper">
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1">15. Verbleib der Reststoffe:</div>
        <!-- <b-form-input
            style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange"
            id="restOfResidues"
            v-model="formData.restOfResidues"
            type="text"
            class="form-control"
            :placeholder="''"
            size="sm"
          /> -->
        <div style="width: 50%; flex-shrink: 0; flex-grow: 1; background-color: orange" class="form-control-sm">
          {{ formData.restOfResidues }}
        </div>
      </div>
    </div>
    <b-button type="button" variant="primary" class="btn-sign-in" size="sm" :disabled="!isFormValid" @click="onSubmit">
      {{ 'save' | i18n }}
    </b-button>
    <!-- </b-form> -->
  </div>
</template>

<script>
import DateRange from '../../common/date-range';
import Textarea from '../../common/textarea';
import api from '../../../api';
import moment from 'moment';
import axios from 'axios';

export default {
  title: 'Neues Deckblatt',
  components: { DateRange, Textarea },
  data() {
    return {
      deckblatt: api.deckblatt,
      formData: {
        date: '',
        groundskeeper: '',
        quantityOfDeliveredWaste: 0,
        quantityOfDeliveredResidues: 0,
        documentationSamplesTakesOfResidues: 'BTB Abfallbeauftragter',
        measuresAtNonApprovedDelivery: '',
        technicalMalfunction: 'Einträge BfS',
        otherMalfunction: 'keine',
        operatingTimesOfSystem: 'Einträge BDS',
        complaintsFromResidents: 'Einträge BfS',
        transportPermitNumber: 'nicht relevant',
        deliveredAmountOfWaste: '',
        heizwertDetermination: 'Einträge BDS',
        compositionOfWasteQuantities: '',
        restOfResidues: 'BTB Abfallbeauftragter',
      },
      isFormValid: true,
      startDate: null,
      endDate: null,
      date: moment().endOf('month').format('DD.MM.yyyy'),
    };
  },
  watch: {
    formData: {
      handler: function (value) {},
      deep: true,
    },
  },
  async mounted() {
    try {
      const l = this.$veLoading({
        target: document.querySelector('#loading-container'),
        name: 'wave',
      });
      this.setLoadingInstance(l);
      this.startLoading();
      const data = await api.deckblatt.getDataForNewDeckblatt({});

      this.stopLoading();

      this.formData.date = moment(data.date).format('DD.MM.yyyy');
      this.formData.groundskeeper = data.platzwart;
      this.formData.quantityOfDeliveredWaste = data.angelieferte_abfaelle;
      this.formData.quantityOfDeliveredResidues = data.angelieferte_reststoffe;
    } catch (error) {
      this.stopLoading();
      console.log('error', error);
    }
  },
  methods: {
    async onSubmit(evt) {
      evt.preventDefault();
      try {
        // await this.deckblatt.create({
        //   ...this.formData,
        // });
        // this.$router.go(-1);
        const baseUrl = axios.defaults.baseURL;
        const auth = JSON.parse(localStorage.getItem('auth'));
        const token = auth.access_token;

        fetch(`${baseUrl}/api/v1/gmva/deckblatt`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
            'Accept': 'application/json',
          },
          body: JSON.stringify({
            ...this.formData,
          },)
        });
        this.$router.go(-1);
      } catch (error) {
        console.log('error', error);
      }
    },
    setLoadingInstance(loadingInstance) {
      this.loadingInstance = loadingInstance;
    },
    startLoading() {
      this.loadingInstance.show();
    },
    stopLoading() {
      this.loadingInstance.close();
    },
    handleChange(e) {
      e.preventDefault();
    },
  },
};
</script>

<style lang="scss">
.inputWrapper {
  display: flex;
  align-items: center;
  padding: 5px 10px;
}
.textarea-wrapper {
  div {
    div {
      textarea {
        padding: 40px 12px 12px !important;
      }
    }
  }
}
.title-wrapper {
  flex-direction: column;
}
.title {
  font-weight: 400;
  font-size: 22px;
  line-height: 36px;
  color: #0f2041;
}

.subtitle {
  font-weight: 400;
  font-size: 18px;
  line-height: 36px;
  color: #0f2041;
}
</style>
